export default class HaptikFeedback {
  static dragStart() {
    if (navigator.vibrate) {
      navigator.vibrate(10);
    }
  }

  static click() {
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  }
}
